export interface IrisReportResponse {
  civilId: string;
  irisUsers: IrisUser[];
}

export class IrisSummaryFiltersDTO {
  dateFrom?: string;
  dateTo?: string;
  description?: string;
  amountFrom?: number;
  amountTo?: number;
}

export interface IrisUser {
  brand: string;
  email: string;
  name: string;
  bankAccounts: IrisBankAccount[];
}

export interface IrisBankAccount {
  id: number;
  name: string;
  iban: string;
  product: string;
  ownerName: string;
  currency: string;
  bankName: string;
  country: string;
  consents: IrisConsent[];
  balances: IrisBalance[];
  transactions: IrisTransaction[];
}

export interface IrisConsent {
  ibanId: number;
  valid_until: string;
  frequency_per_day: number;
  created_at: string;
  status: IrisConsentStatus;
  permissions?: IrisConsentPermission[];
}

export interface IrisBalance {
  amount: number;
  currency: string;
  balanceType: IrisBalanceType;
  referenceDate: string | null;
  creditLimitIncluded: boolean | null;
}

export interface IrisTransaction {
  transactionId: string;
  bookingDate: string;
  creditorAccount: { iban: string } | null;
  creditorName: string | null;
  debtorAccount: { iban: string } | null;
  debtorName: string | null;
  entryReference: string | null;
  remittanceInformationUnstructured: string | null;
  transactionAmount: IrisTransactionAmount;
  exchangeRate: IrisExchangeRate | null;
  valueDate: string;
  creditDebitIndicator: IrisCreditDebitIndicator;
  category?: IrisTransactionCategory;
}

export interface IrisTransactionAmount {
  amount: number;
  currency: string;
}

export interface IrisExchangeRate {
  currencyFrom: string;
  rateFrom: string;
  currencyTo: string;
  rateTo: string;
  rateDate: string;
}

export interface IrisTransactionCategory {
  code: string;
  name: string;
}

export interface IrisReportSummary {
  civilId: string;
  totalAccounts: number;
  totalBalance: number;
  hasValidConsent: boolean;
  brands: IrisBrandSummary[];
}

export interface IrisBrandSummary {
  brand: string;
  name: string;
  accounts: IrisAccountSummary[];
}

export interface IrisAccountSummary {
  iban: string;
  bankName: string;
  currency: string;
  ownerName: string;
  balance: number | null;
  consentStatus: string;
  consentValidUntil: string | null;
  transactionCount: number;
}

export enum IrisCreditDebitIndicator {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
}

export enum IrisConsentStatus {
  RECEIVED = 'received',
  REJECTED = 'rejected',
  VALID = 'valid',
  AUTHORISED = 'Authorised',
  REVOKED_BY_PSU = 'revokedByPsu',
  EXPIRED = 'expired',
  TERMINATED_BY_TPP = 'terminatedByTpp',
  PARTIALLY_AUTHORISED = 'partiallyAuthorised',
}

export enum IrisBalanceType {
  INTERIM_AVAILABLE = 'interimAvailable',
  OPENING_BOOKED = 'openingBooked',
  EXPECTED = 'expected',
  AUTHORISED = 'authorised',
  FORWARD_AVAILABLE = 'forwardAvailable',
  INFORMATION = 'information',
  CLOSING_BOOKED = 'closingBooked',
  INTERIM_BOOKED = 'interimBooked',
}

export enum IrisConsentPermission {
  ACCOUNTS = 'ACCOUNTS',
  BALANCES = 'BALANCES',
  TRANSACTIONS = 'TRANSACTIONS',
  PAYMENTS = 'PAYMENTS',
}

export interface TransactionDirectionStyle {
  icon: string;
  color: string;
  label: string;
}

export const TRANSACTION_DIRECTION_STYLE_MAP: { [key in IrisCreditDebitIndicator]: TransactionDirectionStyle } = {
  [IrisCreditDebitIndicator.CREDIT]: {
    icon: 'call_received',
    color: '#23a800',
    label: 'bankInfo.incoming',
  },
  [IrisCreditDebitIndicator.DEBIT]: {
    icon: 'call_made',
    color: '#c9211e',
    label: 'bankInfo.outgoing',
  },
};